"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var employees = document.querySelectorAll("ul li");
var employeesArray = _to_consumable_array(employees);
function sortList(list) {
    var sortedEmployees = list.sort(function(employee1, employee2) {
        return getSalary(employee2) - getSalary(employee1);
    });
    return sortedEmployees;
}
function getSalary(employee) {
    var employeeSalary = employee.dataset.salary.replace("$", "").replace(",", "");
    return +employeeSalary;
}
function getEmployees(list) {
    return list.map(function(employee) {
        var employeeName = employee.textContent.trim();
        var position = employee.dataset.position;
        var salary = getSalary(employee);
        var age = +employee.dataset.age;
        return {
            name: employeeName,
            position: position,
            salary: salary,
            age: age
        };
    });
}
sortList(employeesArray).forEach(function(employee) {
    employee.parentNode.appendChild(employee);
});
var employeesData = getEmployees(employeesArray);
// eslint-disable-next-line no-console
console.log(employeesData);

//# sourceMappingURL=index.5e14d3cc.js.map
